import { Box } from '@wds/box';
import React from 'react';
import { Logo } from '@sm/webassets/Logos';
import { Typography } from '@wds/typography';
import { t } from '@sm/intl';
import { createUseStyles } from 'react-jss';
import { STANDARD_ENDPAGE_DEFAULT_COPY } from '~app/pages/SurveyThanks/StandardEndpage/copy';
import { CmsWrenchTheme } from '~app/styles/cmsTheme';

const useStyles = createUseStyles(({ type, breakpoints, spacing, brandColors }: CmsWrenchTheme) => ({
  container: {
    width: '100%',
    height: '74px',
  },
  brandedLogo: {
    marginLeft: spacing[2],
    paddingBottom: spacing[1],
    '& svg': {
      width: '100%',
      height: '100%',
      fill: brandColors.neutral.white,
    },
  },
  logoHeightDefault: {
    height: 26,
    [`@media (min-width: ${breakpoints.md}px)`]: { height: 40 },
  },
  logoHeightWithUtSource2: {
    height: 40,
    [`@media (min-width: ${breakpoints.md}px)`]: { height: 40 },
  },
  buildWithAIContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: spacing[2],
    '& span': {
      color: brandColors.neutral.white,
      fontSize: type.fontSize.body,
      textAlign: 'center',
      fontWeight: type.fontWeight.medium,
      [`@media (min-width: ${breakpoints.md}px)`]: {
        fontSize: type.fontSize.sectionTitle,
      },
    },
    [`@media (min-width: ${breakpoints.md}px)`]: {
      gap: spacing[4],
    },
  },
}));

const StaticThanksHeader = ({
  buildWithAI,
  utSource2 = '',
}: {
  buildWithAI?: boolean;
  utSource2?: string;
}): React.ReactElement => {
  const classes = useStyles();

  const logoHeightClass = utSource2 ? classes.logoHeightWithUtSource2 : classes.logoHeightDefault;
  const logoClassName = `${classes.brandedLogo} ${logoHeightClass}`;

  return (
    <Box className={`${classes.container} ${classes.buildWithAIContainer}`}>
      <Logo className={logoClassName} />
      {!buildWithAI && (
        <Typography variant="cardTitle" weight="medium" component="span">
          {t(STANDARD_ENDPAGE_DEFAULT_COPY.ENDPAGE_HEADER)}
        </Typography>
      )}
    </Box>
  );
};

export default StaticThanksHeader;
